import { t } from "./i18n";

type ActiveHostUtilityOptions = {
    roomCode: string;
    controllerConnected?: boolean;
    rootClassName?: string;
    actionsClassName?: string;
    joinPanelClassName?: string;
    qrButtonClassName?: string;
    qrFrameClassName?: string;
    controllerButtonClassName?: string;
    showControllerButton?: boolean;
    showEndGameButton?: boolean;
    extraActionsMarkup?: string;
};

const escapeHtml = (value: string): string =>
    value.replace(/[&<>"']/g, (character) => {
        switch (character) {
            case "&":
                return "&amp;";
            case "<":
                return "&lt;";
            case ">":
                return "&gt;";
            case '"':
                return "&quot;";
            case "'":
                return "&#39;";
            default:
                return character;
        }
    });

const classNames = (...values: Array<string | false | null | undefined>): string => values.filter(Boolean).join(" ");

// Shared by active host screens that need join QR, controller QR, and end-game controls.
export const renderActiveHostJoinUtility = ({
    roomCode,
    controllerConnected = false,
    rootClassName = "",
    actionsClassName = "",
    joinPanelClassName = "",
    qrButtonClassName = "",
    qrFrameClassName = "",
    controllerButtonClassName = "",
    showControllerButton = true,
    showEndGameButton = true,
    extraActionsMarkup = ""
}: ActiveHostUtilityOptions): string => {
    const controllerActionLabel = controllerConnected ? t("hostController") : t("hostControllerQrTitle");

    return `
        <div class="${classNames("active-host-utility-strip", rootClassName)}">
            <div class="${classNames("active-host-join-panel", joinPanelClassName)}">
                <div class="active-room-code-stack">
                    <div class="room-code-display active-room-code-display" data-room-code-text>${escapeHtml(
                        roomCode
                    )}</div>
                </div>
                <button
                    class="${classNames("active-room-qr-button", qrButtonClassName)}"
                    type="button"
                    data-open-qr-preview
                    data-qr-kind="join"
                    aria-label="${escapeHtml(t("showQrCodeToJoin"))}"
                >
                    <span class="${classNames("room-qr-frame active-room-qr-frame", qrFrameClassName)}">
                        <img data-room-qr-image data-room-qr-target="join" alt="${escapeHtml(t("scanToJoin"))}" hidden />
                        <span class="room-qr-placeholder">QR</span>
                    </span>
                    <span class="room-qr-frame active-room-qr-hover-preview" aria-hidden="true">
                        <img data-room-qr-image data-room-qr-target="join" alt="" hidden />
                    </span>
                </button>
            </div>
            <div class="${classNames("active-host-utility-actions", actionsClassName)}">
                ${extraActionsMarkup}
                ${
                    showControllerButton
                        ? `<button
                                class="${classNames(
                                    "secondary-button active-host-controller-button",
                                    controllerButtonClassName,
                                    controllerConnected ? "is-connected" : ""
                                )}"
                                type="button"
                                data-open-qr-preview
                                data-qr-kind="controller"
                                aria-label="${escapeHtml(t("showHostControllerQr"))}"
                                title="${escapeHtml(t("showHostControllerQr"))}"
                            >${escapeHtml(controllerActionLabel)}</button>`
                        : ""
                }
                ${
                    showEndGameButton
                        ? `<button class="secondary-button danger-button active-host-end-button" type="button" data-end-game>${escapeHtml(
                              t("endGame")
                          )}</button>`
                        : ""
                }
            </div>
        </div>
    `;
};
